import { PaymentMethodType } from '../schemas/evaluationSchema';
import { EligibilityCheckResult } from '../SyntaxComps/EligibilityCard';

/**
 * Logic to determine if given an eligibility result and payment billingInfoType, the user can proceed to booking their evaluation
 */
export const signupCanBookEvaluation = ({
  billingInfoType,
  eligibilityResult,
  hasEnteredCCInfo,
  isPreApprovedEligibility,
}: {
  eligibilityResult?: EligibilityCheckResult;
  billingInfoType: PaymentMethodType;
  isPreApprovedEligibility?: boolean;
  hasEnteredCCInfo?: boolean;
}) => {
  if (billingInfoType === PaymentMethodType.COMMERCIAL) {
    if (eligibilityResult === EligibilityCheckResult.IN_NETWORK || isPreApprovedEligibility) {
      return hasEnteredCCInfo;
    }

    if (eligibilityResult === EligibilityCheckResult.OUT_OF_NETWORK) {
      return hasEnteredCCInfo;
    }
    return true;
  } else if (billingInfoType === PaymentMethodType.MEDICARE) {
    // Medicare always requires credit card collection (patient responsibility with $0 deposit)
    if (eligibilityResult === EligibilityCheckResult.IN_NETWORK || isPreApprovedEligibility) {
      return hasEnteredCCInfo;
    }
    return true;
  } else {
    return true;
  }
};
